// extracted by mini-css-extract-plugin
export var container = "_5t-1";
export var cornerButtonContainer = "_5t-6";
export var disabled = "_5t-2";
export var dragActive = "_5t-3";
export var fileContainer = "_5t-5";
export var hiddenInput = "_5t-4";
export var widthContainer = "_5t-0";